export const endorsements_text = {
  block: 'why_running',
};
